import { rutinInfos } from '../../_Common/Const/RutinInfo';
import type React from 'react';
import notImplemented from '../../_Common/Components/notImplemented/notImplemented';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';
import { IRoutine, ShowDetailsRight } from '../../_Common/Const/Delsystem';
import { KalenderCustomUrvalButton } from './Kalender/Components/KalenderCustomUrvalButton';
import { useStatistikrapporteringFunktionsMenyItems } from './Statistikrapportering/Statistikrapportering';
import { useStatistikrapporteringOnStartWarningHook } from './Statistikrapportering/Utils/useStatistikrapporteringOnStartWarningHook';
import { TEDBOAktivitetTypEnum } from '../../../../globalQueryTypes';
import KalenderWrapper from './Kalender/Components/KalenderWrapper';
import { AktivitetTypUnderMeny } from './AktivitetTypUnderMeny';
import { useKalenderBusinessCollectionMenuItems } from './Kalender/Hooks/useKalenderBusinessCollectionMenuItems';
import StatistikrapporteringQuery from '../ObjektVyer/Statistikrapportering/Queries/StatistikrapporteringQuery.gql';
import StatistikrapporteringAldersindelningQuery from '../ObjektVyer/Statistikrapportering/Queries/StatistikrapporteringAldersindelningQuery.gql';
import xbridgeQuery from './Kalender/Queries/XbridgeQuery/BOGetXBridgeBookings.gql';
import { KalenderToolbarResourceList } from './KalenderToolbarResourcesList';
import KalenderSideMenuToolbar from './KalenderSideMenyToolbar';
import { getUseAktivitetFunktionsMenyItems } from '../ObjektVyer/Aktivitet/UseAktivitetFunktionsMenyItems';

const BORutiner: { [rtnKey: string]: IRoutine } = {
  rtnGudstjansttyp: {
    component: getStandardRutin(rutinInfos.rtnGudstjansttyp, 'BOGudstjansttyp'),
  },
  rtnAktiviteter: {
    component: getStandardRutin(
      rutinInfos.rtnAktiviteter,
      'BOAktivitet',
      getUseAktivitetFunktionsMenyItems(false)
    ),
    customAddButton: AktivitetTypUnderMeny,
    directEditMode: true,
  },
  rtnWebKalender: {
    component: getStandardRutin(
      rutinInfos.rtnWebKalender,
      'BOBokningsrubrik',
      undefined,
      useKalenderBusinessCollectionMenuItems,
      KalenderWrapper
    ),
    detaljVyCollectionName: 'BOAktivitet',
    detaljVyAssociationName: 'Aktivitet',
    customAddButton: AktivitetTypUnderMeny,
    customBottomToolbar: KalenderToolbarResourceList,
    customTopToolbar: KalenderSideMenuToolbar as React.FunctionComponent<
      React.PropsWithChildren<unknown>
    >,
    defaultVisningsTyp: 'kalender',
    unusedRoutineMenuButtons: ['column', 'sort'],
    customUrvalButton: KalenderCustomUrvalButton as React.FunctionComponent<
      React.PropsWithChildren<unknown>
    >,
    defaultShowDetailsRight: ShowDetailsRight.DefaultFalse,
    directEditMode: true,
    rutinPanelFullHeight: true,
    filterAttributes: [
      { attribute: 'Aktivitet.BOKNINGSNUMMER', label: 'bok.nr' },
      { attribute: 'FRANDATUM', label: '' },
      { attribute: 'Aktivitet.TITEL', label: 'titel' },
      { attribute: 'Aktivitet._typ', label: '' },
      { attribute: 'RESURS_NAMN', label: 'resurs' },
      { attribute: 'Resursrubrik', label: '' },
      { attribute: 'Aktivitet.AktBokRubrik.RESURS_NAMN', label: '' },
    ],
    hideStandardListFilter: 'xl',
    config: {
      BOBokning: {
        refetchButtonQueries: [xbridgeQuery, 'nodeBOAktivitet'],
      },
    },
  },
  rtnWebPlanering: {
    component: getStandardRutin(
      rutinInfos.rtnWebPlanering,
      'BOPlanering',
      getUseAktivitetFunktionsMenyItems(false)
    ),
    customAddButton: AktivitetTypUnderMeny,
    directEditMode: true,
    defaultVisningsTyp: 'planering',
  },
  rtnFakturaOmgang: {
    component: getStandardRutin(rutinInfos.rtnFakturaOmgang, 'BOFaktOmg'),
  },
  rtnResurser: {
    component: getStandardRutin(rutinInfos.rtnResurser, 'BOResurs'),
  },
  rtnOPGrupp: {
    component: getStandardRutin(rutinInfos.rtnOPGrupp, 'BOGruppOP'),
  },
  rtnGruppmedlemmar: {
    component: getStandardRutin(
      rutinInfos.rtnGruppmedlemmar,
      'BOGruppmedlemOP'
    ),
  },
  rtnSammankomst: {
    component: getStandardRutin(rutinInfos.rtnSammankomst, 'BOSammankomst'),
  },
  rtnStatistikrapporteringNew: {
    component: getStandardRutin(
      rutinInfos.rtnStatistikrapporteringNew,
      'BOAktivitet',
      useStatistikrapporteringFunktionsMenyItems
    ),
    detaljVy: 'statistik',
    config: {
      BOAktivitet: {
        defaultColumns: [
          { attributeDef: 'Titel2', caption: 'Titel', header: true },
          {
            attributeDef: '_typ',
            caption: 'Aktivitetstyp',
            hideCaption: true,
            minSize: 'sm',
          },
          { attributeDef: 'DatumOchTid' },
          { attributeDef: 'Resurs1.RESURS_NAMN', caption: 'Plats' },
          { attributeDef: 'TotalaBesokare', caption: 'Antal besökare' },
          { attributeDef: 'StatistikStatus', caption: 'Status', minSize: 'sm' },
        ],
        defaultSort: [
          { attributeName: 'DatumOchTid', order: 'asc' },
          { attributeName: 'Resurs1.RESURS_NAMN', order: 'asc' },
        ],
        userDeleteable: false,
        refetchButtonQueries: [
          StatistikrapporteringAldersindelningQuery,
          StatistikrapporteringQuery,
        ],
      },
    },
    hideDefaultFunktionsMenyItems: true,
    defaultShowDetailsRight: ShowDetailsRight.DefaultTrue,
    showDetailsRightSize: '400px',
    directEditMode: true,
    initialUrval: 'DNMcriJHTNhggpiiVTYsffhjFkbcnuOu', // 'Grundurval',
    defaultVisningsTyp: 'tabell',
    defaultVisningsTypShowDetailsRight: 'tabell',
    filterAttributes: [
      { attribute: 'Titel2', label: 'Titel' },
      { attribute: '_typ', label: 'Aktivitetstyp' },
      { attribute: 'DatumOchTid', label: 'Datum' },
      { attribute: 'Resurs1.RESURS_NAMN', label: 'Plats' },
    ],
    onStartWarningHook: useStatistikrapporteringOnStartWarningHook,
    optInDataRefreshDesktop: true,
    optInDataRefreshMobile: true,
    miniCardColor: data => {
      let preliminar = data['PRELBOKAD'];
      switch (data._typ) {
        case TEDBOAktivitetTypEnum.AKTOVRIGT:
          if (preliminar) {
            return 'preliminarAktovrigt';
          } else {
            return 'aktovrigt';
          }
        case TEDBOAktivitetTypEnum.BEGRAVNING:
          if (preliminar) {
            return 'preliminarBegravning';
          } else {
            return 'begravning';
          }
        case TEDBOAktivitetTypEnum.DOP:
          if (preliminar) {
            return 'preliminarDop';
          } else {
            return 'dop';
          }
        case TEDBOAktivitetTypEnum.GRAVSATTNING:
          if (preliminar) {
            return 'preliminarGravsattning';
          } else {
            return 'gravsattning';
          }
        case TEDBOAktivitetTypEnum.GUDSTJANST:
          if (preliminar) {
            return 'preliminarGudstjanst';
          } else {
            return 'gudstjanst';
          }

        case TEDBOAktivitetTypEnum.KONFIRMATION:
          if (preliminar) {
            return 'preliminarKonfirmation';
          } else {
            return 'konfirmation';
          }
        case TEDBOAktivitetTypEnum.LOKALUTHYRNING:
          if (preliminar) {
            return 'preliminarLokaluthyrning';
          } else {
            return 'lokaluthyrning';
          }
        case TEDBOAktivitetTypEnum.OUTLOOK:
          if (preliminar) {
            return 'preliminarOutlook';
          } else {
            return 'outlook';
          }
        case TEDBOAktivitetTypEnum.SNABBOKNING:
          if (preliminar) {
            return 'preliminarSnabbokning';
          } else {
            return 'snabbokning';
          }
        case TEDBOAktivitetTypEnum.VIGSEL:
          if (preliminar) {
            return 'preliminarVigsel';
          } else {
            return 'vigsel';
          }
        default:
          return undefined;
      }
    },
    unusedRoutineMenuButtons: ['add'],
  },
  rtnAnnonseras: {
    component: notImplemented('Annonseras'),
  },
  rtnBestallningar: {
    component: getStandardRutin(rutinInfos.rtnBestallningar, 'BOAktivitet'),
  },
};

export default BORutiner;
